/* globals ga */

import $ from 'jquery';

class GAEventTracking {
    constructor (options = {}) {
        if (options.downloads !== false) {
            // Download Clicks
            this.trackDownloadLinks();
        }

        if (options.outbound !== false) {
            // Outbound Link Clicks
            this.trackOutboundLinks();
        }

        if (options.email !== false) {
            // Email Link Clicks
            this.trackEmailLinks();
        }

        if (options.custom !== false) {
            // Custom Tracked Links
            this.trackCustomButtons('.js-ga-button');
        }
    }

    /**
     * Google Analytics event tracking
     *
     * @param {string} category
     * @param {string} action
     * @param {string} label
     *
     */
    trackAnalyticEvent (category, action, label) {
        // console.log(category, action, label);

        ga('send', 'event', category, action, label, {
            'page'           : decodeURI(window.location),
            'nonInteraction' : 1
        });

        return this;
    }

    /**
     * Download Link tracking (/files/ links)
     */
    trackDownloadLinks () {
        const trackAnalyticEvent = this.trackAnalyticEvent;

        this.$downloadLinks = $(`a[href*="${location.hostname}/wp-content/uploads"], a[href^="/wp-content/uploads"]`);

        this.$downloadLinks.click(function () {
            const href     = $(this).attr('href').replace(location.origin, '');
            const fileType = href.split('.').pop().toUpperCase();

            // Category = "Downloads"
            // Action = File Type ("DOCX", "PDF", etc)
            // Label = URL to the file
            trackAnalyticEvent('Downloads', fileType, href);
        });
    }

    /**
     * mailto: Click tracking
     */
    trackEmailLinks () {
        const trackAnalyticEvent = this.trackAnalyticEvent;

        this.$emailLinks = $('a[href^="mailto:"]');

        this.$emailLinks.on('click', function () {
            // Split the mailto link into parts (to strip out "mailto:", "?subject=", etc)
            const mailtoParts    = $(this).attr('href').match(/^mailto:((?:(?:(?:[^:@]*)@)(?:[^:?]*)))?((?:[^?]*)(?:\?([^]*))?)/);
            // Validate the part found is an email
            const emailValidator = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (mailtoParts[1] && emailValidator.test(mailtoParts[1])) {
                // Category = "Mails"
                // Action = "Click"
                // Label = The email address
                trackAnalyticEvent('Mails', 'Click', mailtoParts[1]);
            }
        });
    }

    /**
     * External website link tracking
     */
    trackOutboundLinks () {
        const trackAnalyticEvent = this.trackAnalyticEvent;

        this.$externalLinks = $('a').filter(function () {
            return this.hostname && this.hostname !== location.hostname;
        }).addClass('external');

        this.$externalLinks.on('click', function () {
            // Category = 'Outbound links'
            // Action = 'Click'
            // Label = The URL
            trackAnalyticEvent('Outbound links', 'Click', $(this).attr('href'));
        });
    }

    trackCustomButtons (selector) {
        const trackAnalyticEvent = this.trackAnalyticEvent;

        this.$customLinks = $(selector);

        this.$customLinks.click(function () {
            let category = 'Custom';
            let action   = 'Click';
            const label  = $(this).attr('href');

            if ($(this).data('ga-category')) {
                category = $(this).data('ga-category');
            }

            if ($(this).data('ga-action')) {
                action = $(this).data('ga-action');
            }

            if ($(this).data('ga-label')) {
                action = $(this).data('ga-label');
            }

            // Category = "Downloads"
            // Action = File Type ("DOCX", "PDF", etc)
            // Label = URL to the file
            trackAnalyticEvent(category, action, label);
        });
    }
}
export default GAEventTracking;
